import gql from 'graphql-tag'

export const GET_AUDIENCE_QUERY = gql`
  query ($limit: Int = 5, $offset: Int = 0, $where: audience_bool_exp) {
    audience(
      offset: $offset
      limit: $limit
      order_by: { created_at: desc }
      where: $where
    ) {
      id
      description
      additional_info
      name
      type
      ai_reminder: enabled_ai_reminder
      created_at
      messages_by_audiences {
        audience_id
        message
      }
      phone_number
    }
    audience_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`

export const ADD_AUDIENCE_MUTATION = gql`
  mutation ($audience: AddAudienceInput!) {
    addAudience(audience: $audience) {
      id
    }
  }
`

export const GET_PHONENUMBERS_MUTATION = gql`
  query {
    getPhoneNumbers {
      numbers
    }
  }
`

export const SEND_TEST_EMAIL_MUTATION = gql`
  mutation ($emailData: SendTestEmailInput!) {
    sendTestEmail(emailData: $emailData) {
      success
    }
  }
`

export const REMOVE_AUDIENCE_MUTATION = gql`
  mutation ($audience: RemoveAudienceInput!) {
    removeAudience(audience: $audience) {
      affected_rows
    }
  }
`

export const SET_CAMPAIGN_SCHEDULERS_MUTATION = gql`
  mutation ($audience_id: uuid!, $disabled: Boolean!) {
    setCampaignSchedulers(audience_id: $audience_id, disabled: $disabled) {
      affected_rows
      disabled
    }
  }
`
